import axios from 'axios';
import { createZirveNovaSmsPayload } from './zirveNovaAuth';

let BASE_URL = process.env.REACT_APP_INT_URL;

const zirveNovaRequest = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

const loginZirveNova = async (username, password) => {
    return await zirveNovaRequest.post('/zirvenova-defter/login', { username, password });
};

const smsControlZirveNova = async (sessionData, smsCode) => {
    return await zirveNovaRequest.post('/zirvenova-defter/smsControl', createZirveNovaSmsPayload(sessionData, smsCode));
};

export { loginZirveNova, smsControlZirveNova };
